// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/bg-img.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,400&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@100;300;400;700;900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*** Login Page style starts ***/
.login-p {
  display: flex;
  align-items: center;
  height: 100%;
  min-height: 100vh;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.login-section {
  display: flex;
  align-items: center;
  height: 100%;
  flex-direction: column;
  padding: 10px 0;
}
.login-section .copyright {
  text-align: center;
  color: #595959;
  font-size: 14px;
}
.login-section .form-card {
  max-width: 480px;
  width: 100%;
  padding: 25px 30px;
  margin: 5% auto;
  background: #ffffff;
  border: 1px solid #eee;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  border-radius: 10px;
}
.login-section .ant-btn-primary.login-button {
  background: #a6a300 !important;
  border-color: #a6a300 !important;
  width: 100%;
  height: 55px;
  margin-top: 25px;
}
.login-section .ant-btn-primary.login-button:hover,
.login-section .ant-btn-primary.login-button:focus,
.login-section .ant-btn-primary.login-button:active {
  background: #a6a300 !important;
  border-color: #a6a300 !important;
}
.login-section .logo {
  display: block;
  margin: 15px auto 25px;
  text-align: center;
}
.login-section .form-heading {
  color: #000;
  font-size: 35px;
  font-weight: 700;
  margin-bottom: 20px;
  text-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
}
.link-text {
  color: #a6a300;
  text-decoration: none;
}
.ant-input-affix-wrapper {
  height: 55px;
  border-radius: 4px;
  border: 1px solid #a6a300;
}
.main-sidebar {
  background: #212329;
}
.main-sidebar .menu {
  background: #212329;
  border-right: 0;
}
.main-sidebar .ant-menu .ant-menu-item,
.main-sidebar .ant-menu .ant-menu-submenu-title {
  margin-inline: 0 !important;
  width: 100% !important;
}
.main-sidebar .ant-menu .ant-menu-item {
  align-items: center;
  display: flex;
}
.main-sidebar .ant-menu .ant-menu-item a {
  color: #ffffff;
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
}
.main-sidebar .ant-menu .ant-menu-item svg {
  color: #ffffff;
  fill: #ffffff;
}
.main-sidebar .ant-menu .ant-menu-item .ant-menu-item-icon + span {
  margin-left: 20px;
}
.main-sidebar .ant-menu .ant-menu-item:hover,
.main-sidebar .ant-menu .ant-menu-item:focus {
  background: #333A4B !important;
  border-right: 4px solid #a6a300 !important;
}
.main-sidebar .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background: #333A4B !important;
  border-right: 4px solid #a6a300 !important;
}
.main-sidebar .ant-menu .sidebar-icon {
  font-size: 20px;
}
.main-sidebar.ant-layout-sider .logo-img img {
  width: 80%;
  padding: 5px 0 15px;
  display: block;
  object-fit: contain;
  margin: 0 auto 15px;
}
.ant-menu.ant-menu-dark,
.ant-menu-dark .ant-menu-sub,
.ant-menu.ant-menu-dark .ant-menu-sub {
  background: #212329;
  width: 100% !important;
}
.ant-menu-submenu {
  color: #ffffff;
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  background: #212329;
  border-right: 0;
}
.ant-menu-sub.ant-menu-inline {
  background: #212329;
  color: #ffffff;
}
.ant-menu-inline.ant-menu-root .ant-menu-submenu-title > .ant-menu-title-content {
  margin-left: 20px!important;
}
.ant-menu-title-content,
.ant-menu-submenu-inline,
.ant-menu-submenu-arrow,
.ant-menu-submenu-title svg {
  color: #ffffff;
  fill: #ffffff;
}
.ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background: #333A4B !important;
  border-right: 4px solid #a6a300 !important;
}
.ant-layout-header.header {
  background: #fff !important;
  padding: 0 25px;
}
.create_object .ant-upload {
  width: 100%;
}
/*** breadcrumb style ***/
.app-breadcrumb-col {
  padding: 15px 24px 0;
}
.ant-breadcrumb .ant-breadcrumb-link,
.ant-breadcrumb .ant-breadcrumb-separator {
  font-weight: 500;
  font-size: 16px;
}
.ant-breadcrumb a.ant-breadcrumb-link {
  color: #000 !important;
}
.ant-breadcrumb .ant-breadcrumb-separator {
  color: #000 !important;
}
.white-paper {
  background: #ffffff;
  padding: 15px 24px 24px;
  margin-top: 20px;
  width: 100%;
  min-height: calc(100vh - 200px);
}
.white-paper hr {
  margin-left: -24px;
  margin-right: -24px;
  margin-top: 15px !important;
  background-color: #cfcfcf !important;
}
.white-paper .page-header-section h4 {
  font-size: 18px;
  font-weight: 700 !important;
  color: #111111;
}
.white-paper .align-right {
  margin-left: auto;
  display: block;
}
.white-paper .align-right .ant-btn-icon {
  margin-inline-end: 8px;
}
.edit-btn {
  cursor: pointer;
}
.edit-btn svg {
  fill: #5D5D5D;
  color: #5D5D5D;
}
.complete-btn {
  cursor: pointer;
}
.complete-btn svg {
  fill: #a6a300;
  color: #a6a300;
}
.ant-picker {
  width: 100%;
}
.ant-input,
.ant-select:not(.ant-select-customize-input) .ant-select-selector,
.ant-picker {
  background-color: #fcfcfc;
  border: 1px solid #e5e5e5;
  height: 40px;
}
/*** buttons design ***/
button.ant-btn {
  height: 40px;
  padding: 0px 15px;
  font-size: 16px;
  font-weight: 400;
}
button.ant-btn.ant-btn-primary:not(.login-button):not(.save-btn) {
  background: #212329 !important;
  border-color: #212329 !important;
  color: #ffffff !important;
}
button.ant-btn.ant-btn-primary:not(.login-button):not(.save-btn):hover,
button.ant-btn.ant-btn-primary:not(.login-button):not(.save-btn):focus,
button.ant-btn.ant-btn-primary:not(.login-button):not(.save-btn):active {
  background: #212329 !important;
  border-color: #212329 !important;
  color: #ffffff !important;
}
button.ant-btn.ant-btn-primary:not(.login-button):not(.save-btn):disabled,
button.ant-btn.ant-btn-primary:not(.login-button):not(.save-btn).ant-btn-disabled,
button.ant-btn.ant-btn-primary:not(.login-button):not(.save-btn):disabled:hover,
button.ant-btn.ant-btn-primary:not(.login-button):not(.save-btn).ant-btn-disabled:hover {
  background: #f5f5f5 !important;
  border-color: #d9d9d9 !important;
  color: rgba(0, 0, 0, 0.25) !important;
  cursor: not-allowed;
  box-shadow: none;
}
button.ant-btn.save-btn {
  background: #a6a300 !important;
  border-color: #a6a300 !important;
  color: #ffffff !important;
}
button.ant-btn.save-btn:hover,
button.ant-btn.save-btn:focus,
button.ant-btn.save-btn:active {
  background: #a6a300 !important;
  border-color: #a6a300 !important;
  color: #ffffff !important;
}
button.ant-btn.ant-btn-dangerous {
  background: #e23c39 !important;
  border-color: #e23c39 !important;
  color: #fff !important;
}
button.ant-btn.ant-btn-dangerous:hover,
button.ant-btn.ant-btn-dangerous:focus,
button.ant-btn.ant-btn-dangerous:active {
  background: #e23c39 !important;
  border-color: #e23c39 !important;
  color: #fff !important;
}
button.ant-btn.ant-btn-default:not(.ant-btn-dangerous):not([style]) {
  background: #73c053 !important;
  border-color: #73c053 !important;
  color: white !important;
}
button.ant-btn.ant-btn-default:not(.ant-btn-dangerous):not([style]):hover,
button.ant-btn.ant-btn-default:not(.ant-btn-dangerous):not([style]):focus,
button.ant-btn.ant-btn-default:not(.ant-btn-dangerous):not([style]):active {
  background: #73c053 !important;
  border-color: #73c053 !important;
  color: white !important;
}
/*** Table layout design ***/
table .ant-table-thead th {
  font-size: 14px !important;
  font-weight: 500 !important;
}
table .ant-table-thead th:not(.dark-table-header) {
  color: #595959 !important;
}
table .ant-table-thead th span {
  color: #595959;
  font-size: 14px;
  font-weight: 500;
  white-space: normal;
  word-wrap: break-word;
}
table .ant-table-thead th .ant-table-filter-trigger.active span {
  color: #a6a300;
}
table .ant-table-tbody td {
  color: #595959;
  font-size: 14px;
  font-weight: 400;
}
.ant-table-content table .ant-table-thead > tr > th:last-child,
.ant-table-container table .ant-table-thead > tr > th:last-child {
  position: sticky;
  right: 0;
  z-index: 2;
  background: #fafafa;
  box-shadow: -6px 0 6px -6px rgba(0, 0, 0, 0.15);
}
.ant-table-content table .ant-table-tbody > tr > td:last-child,
.ant-table-container table .ant-table-tbody > tr > td:last-child {
  position: sticky;
  right: 0;
  z-index: 1;
  background: #ffffff;
  box-shadow: -6px 0 6px -6px rgba(0, 0, 0, 0.15);
}
.ant-table-content table .ant-table-tbody > tr:hover > td:last-child,
.ant-table-container table .ant-table-tbody > tr:hover > td:last-child {
  background: #fafafa;
}
.no-fixed-last-col .ant-table-thead > tr > th:last-child,
.no-fixed-last-col .ant-table-tbody > tr > td:last-child {
  position: static !important;
  box-shadow: none !important;
}
button.ant-btn.ant-btn-link {
  color: #a6a300;
}
.custom_modal .ant-modal-confirm-btns {
  display: none;
}
.custom_modal .custom_button {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 20px;
}
.custom_modal .custom_button button:last-child {
  margin-left: 10px;
}
.disabledComponent {
  pointer-events: none;
  cursor: not-allowed;
  opacity: 0.3;
}
.print-icon {
  cursor: pointer;
}
.print-icon svg {
  fill: #5D5D5D;
  color: #5D5D5D;
}
/*** Shared upload trigger — used by every <Upload> in the app (see UploadTrigger.js) ***/
.bp-upload-trigger {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-height: 52px;
  padding: 8px 16px;
  border: 1px dashed #c9c9c9;
  border-radius: 8px;
  background: #fafafa;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
  box-sizing: border-box;
}
.bp-upload-trigger:hover {
  border-color: #a6a300;
  background: rgba(166, 163, 0, 0.06);
}
.bp-upload-trigger .bp-upload-trigger-icon {
  font-size: 18px;
  color: #a6a300;
  flex-shrink: 0;
}
.bp-upload-trigger .bp-upload-trigger-text {
  display: flex;
  flex-direction: column;
  line-height: 1.3;
  min-width: 0;
  overflow: hidden;
}
.bp-upload-trigger .bp-upload-trigger-text span,
.bp-upload-trigger .bp-upload-trigger-text small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.bp-upload-trigger .bp-upload-trigger-text span {
  font-size: 14px;
  font-weight: 500;
  color: #111111;
}
.bp-upload-trigger .bp-upload-trigger-text small {
  font-size: 11px;
  color: rgba(0, 0, 0, 0.45);
}
.bp-upload-trigger.bp-upload-trigger--disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
.bp-upload-trigger.bp-upload-trigger--disabled:hover {
  border-color: #c9c9c9;
  background: #fafafa;
}
@media (max-width: 575px) {
  .bp-upload-trigger {
    gap: 8px;
    padding: 8px 12px;
  }
  .bp-upload-trigger .bp-upload-trigger-icon {
    font-size: 16px;
  }
  .bp-upload-trigger .bp-upload-trigger-text span {
    font-size: 13px;
  }
}
.ant-upload.ant-upload-select:not(.ant-upload-select-picture-card) {
  display: block;
  width: 100%;
}
.ant-upload.ant-upload-select:not(.ant-upload-select-picture-card) > .ant-upload {
  display: block;
  width: 100%;
}
.ant-upload-list-picture .ant-upload-list-item,
.ant-upload-list-text .ant-upload-list-item {
  border-radius: 8px;
  margin-top: 10px;
}
/*** "Already uploaded" tick beside an upload label (see UploadedCheck.js) ***/
.bp-uploaded-check {
  margin-left: 6px;
  color: green;
  font-size: 16px;
  line-height: 1;
  vertical-align: -0.15em;
}
/*** Basic Photos page ***/
.basic-photo-page .bp-section-card {
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
  margin-bottom: 20px;
  overflow: hidden;
}
.basic-photo-page .bp-section-card .ant-card-head {
  border-bottom: 1px solid #f0f0f0;
  min-height: unset;
  padding: 0 20px;
}
.basic-photo-page .bp-section-card .ant-card-head-title {
  padding: 14px 0;
}
.basic-photo-page .bp-section-card .ant-card-body {
  padding: 20px;
}
.basic-photo-page .bp-section-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  background: rgba(166, 163, 0, 0.12);
  color: #a6a300;
  font-size: 16px;
}
.basic-photo-page .bp-section-title {
  font-size: 15px;
  font-weight: 700;
  color: #111111;
  line-height: 1.3;
}
.basic-photo-page .bp-section-desc {
  font-size: 12px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.45);
  line-height: 1.3;
}
.basic-photo-page .bp-array-tabs > .ant-tabs-nav {
  margin-bottom: 16px;
}
.basic-photo-page .bp-array-tabs > .ant-tabs-nav::before {
  border-bottom: none;
}
.basic-photo-page .bp-array-tabs > .ant-tabs-nav .ant-tabs-nav-list {
  gap: 8px;
}
.basic-photo-page .bp-array-tabs > .ant-tabs-nav .ant-tabs-tab {
  background: #fafafa;
  border: 1px solid #eee;
  border-radius: 8px !important;
  padding: 8px 16px !important;
  transition: all 0.2s ease;
}
.basic-photo-page .bp-array-tabs > .ant-tabs-nav .ant-tabs-tab .ant-tabs-tab-btn {
  font-weight: 500;
  color: rgba(0, 0, 0, 0.45);
}
.basic-photo-page .bp-array-tabs > .ant-tabs-nav .ant-tabs-tab .ant-tabs-tab-remove {
  color: rgba(0, 0, 0, 0.45);
  margin-left: 8px;
}
.basic-photo-page .bp-array-tabs > .ant-tabs-nav .ant-tabs-tab .ant-tabs-tab-remove:hover {
  color: #900101;
}
.basic-photo-page .bp-array-tabs > .ant-tabs-nav .ant-tabs-tab:hover .ant-tabs-tab-btn {
  color: #a6a300;
}
.basic-photo-page .bp-array-tabs > .ant-tabs-nav .ant-tabs-tab-active {
  background: rgba(166, 163, 0, 0.1);
  border-color: rgba(166, 163, 0, 0.4);
}
.basic-photo-page .bp-array-tabs > .ant-tabs-nav .ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #a6a300 !important;
}
.basic-photo-page .bp-array-tabs > .ant-tabs-nav .ant-tabs-nav-add {
  border-radius: 8px !important;
  border: 1px dashed #c9c9c9 !important;
  color: #a6a300 !important;
  background: #fff !important;
}
.basic-photo-page .bp-array-tabs > .ant-tabs-nav .ant-tabs-nav-add:hover {
  border-color: #a6a300 !important;
  background: rgba(166, 163, 0, 0.06) !important;
}
.basic-photo-page .bp-array-tabs .ant-tabs-tabpane {
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 16px 16px 2px;
}
.basic-photo-page .bp-preview-modal .ant-modal-body {
  padding: 16px;
}
.basic-photo-page .bp-preview-modal img {
  border-radius: 8px;
}
.basic-photo-page .bp-footer-bar {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 8px;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
}
.basic-photo-page .bp-footer-bar .bp-footer-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
/* =========================================================================
   Responsive layer
   Built on antd's own breakpoints so it tracks the grid the JSX uses:
     @screen-xs-max 575px | @screen-sm-max 767px | @screen-md-max 991px
   Desktop (>=lg) is deliberately untouched.
   ========================================================================= */
/* ---- Tablet and below (<=991px) ---- */
@media (max-width: 991px) {
  .white-paper {
    padding: 14px 18px 18px;
  }
  .white-paper hr {
    margin-left: -18px;
    margin-right: -18px;
  }
}
/* ---- Small tablet / large phone (<=767px) ---- */
@media (max-width: 767px) {
  .white-paper {
    padding: 12px 14px 16px;
    margin-top: 14px;
    min-height: auto;
  }
  .white-paper hr {
    margin-left: -14px;
    margin-right: -14px;
  }
  .ant-table .ant-table-thead th,
  .ant-table .ant-table-tbody td {
    padding: 10px 8px !important;
  }
  .ant-modal {
    max-width: calc(100vw - 24px);
    margin: 12px auto;
  }
  .ant-modal .ant-modal-body {
    padding: 16px;
  }
  .custom_modal .custom_button {
    justify-content: stretch;
    flex-wrap: wrap;
  }
  .custom_modal .custom_button button {
    flex: 1 1 auto;
  }
  .custom_modal .custom_button button:last-child {
    margin-left: 0;
  }
}
/* ---- Phones (<=575px) ---- */
@media (max-width: 575px) {
  .white-paper {
    padding: 10px 12px 14px;
    border-radius: 0;
  }
  .white-paper hr {
    margin-left: -12px;
    margin-right: -12px;
  }
  .white-paper .page-header-section {
    row-gap: 10px;
  }
  .white-paper .page-header-section > .ant-col {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .white-paper .page-header-section h4 {
    font-size: 16px;
    line-height: 1.35;
  }
  .white-paper .page-header-section .align-right {
    margin-left: 0;
  }
  .white-paper .page-header-section .ant-btn {
    width: 100%;
  }
  .app-breadcrumb-col .ant-breadcrumb .ant-breadcrumb-link,
  .app-breadcrumb-col .ant-breadcrumb .ant-breadcrumb-separator {
    font-size: 13px;
  }
  button.ant-btn {
    font-size: 14px;
    padding: 0 12px;
  }
  .ant-table-content,
  .ant-table-body {
    -webkit-overflow-scrolling: touch;
  }
  .ant-table {
    font-size: 13px !important;
  }
  .ant-table .ant-table-thead th,
  .ant-table .ant-table-tbody td {
    padding: 8px 6px !important;
  }
  .ant-tabs-nav .ant-tabs-tab {
    margin: 0 4px 0 0 !important;
    padding: 8px 10px !important;
    font-size: 13px;
  }
  .bp-footer-bar {
    padding-top: 14px;
  }
  .bp-footer-bar .bp-footer-actions {
    width: 100%;
  }
  .bp-footer-bar .bp-footer-actions .ant-btn {
    flex: 1 1 100%;
  }
  .ant-pagination {
    display: flex;
    flex-wrap: wrap;
    row-gap: 8px;
  }
  .ant-form-item-label > label {
    height: auto;
    white-space: normal;
  }
}
/* =========================================================================
   App shell: content spacing + phone sider behaviour
   ========================================================================= */
.app-content {
  margin: 20px;
}
.sider-backdrop {
  display: none;
}
@media (max-width: 575px) {
  .app-content {
    margin: 0;
  }
  .main-sidebar.ant-layout-sider-collapsed {
    flex: 0 0 0 !important;
    width: 0 !important;
    min-width: 0 !important;
    max-width: 0 !important;
    overflow: hidden !important;
  }
  .main-sidebar:not(.ant-layout-sider-collapsed) {
    position: fixed !important;
    top: 0;
    left: 0;
    height: 100vh;
    z-index: 1002;
    box-shadow: 2px 0 14px rgba(0, 0, 0, 0.3);
  }
  .sider-backdrop {
    display: block;
    position: fixed;
    inset: 0;
    z-index: 1001;
    background: rgba(0, 0, 0, 0.45);
  }
}
.enlarged-image-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.modal-content {
  max-width: 50%;
  max-height: 50%;
  padding: 20px;
  text-align: center;
  position: relative;
}
.modal-content img {
  max-width: 100%;
  max-height: 100%;
}
.modal-content button {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-size: 20px;
}
.avatar-container {
  width: 230px;
  /* Set the width of the container */
  height: 230px;
  /* Set the height of the container */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.avatar-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  object-position: center;
}
* {
  font-family: 'Lato', sans-serif;
}
body {
  font-family: 'Lato', sans-serif;
}
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
  font-family: "Montserrat", sans-serif;
}
/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}
body {
  line-height: 1;
}
ol,
ul {
  list-style: none;
}
blockquote,
q {
  quotes: none;
}
blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
.shadow {
  -webkit-box-shadow: -1px 2px 9px -1px rgba(0, 0, 0, 0.34);
  -moz-box-shadow: -1px 2px 9px -1px rgba(0, 0, 0, 0.34);
  box-shadow: -1px 2px 9px -1px rgba(0, 0, 0, 0.34);
}
h4.ant-typography {
  font-size: 16px;
  line-height: 40px !important;
  font-weight: 600 !important;
  margin-bottom: 0 !important;
}
hr {
  border: none !important;
  height: 1px !important;
  margin-bottom: 25px;
  display: block !important;
  background: #f0f0f0 !important;
}
.flexbox {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
}
.right-fl {
  float: right;
}
.btn-white {
  background: none;
  color: inherit;
  border-color: inherit;
}
.btn-white:hover {
  background-color: inherit;
  color: inherit;
}
.ant-radio-inner {
  background: none;
}
.tab-title-grant .ant-checkbox-checked:not(.ant-checkbox-disabled) .ant-checkbox-inner {
  background-color: #73c074;
  border-color: #73c074;
}
.tab-title-revoke .ant-checkbox-checked:not(.ant-checkbox-disabled) .ant-checkbox-inner {
  background-color: #df746a;
  border-color: #df746a;
}
strong {
  font-weight: bold !important;
}
.ant-table-cell button {
  background: none;
  border: none;
  color: #0067ae;
}
.ant-switch-inner {
  padding: 0 20px;
}
.labelLink .ant-form-item-label > label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.ant-modal-header {
  background: #212329 !important;
  border-color: #212329 !important;
  color: #ffffff !important;
}
.ant-modal-title,
.ant-modal-close-x {
  color: #ffffff !important;
}
.ant-modal-title,
.ant-select-item-option-content {
  text-transform: capitalize;
}
span.ant-breadcrumb-link {
  color: #a6a300 !important;
}
select {
  text-transform: capitalize;
}
.carousel-container {
  width: 100%;
}
.carousel-item {
  padding: 10px;
}
.ant-carousel .slick-slide {
  display: flex;
  justify-content: center;
  align-items: center;
}
.slick-slide {
  width: 370px !important;
}
.ant-table-cell {
  overflow-wrap: anywhere !important;
}
.carousel-container {
  padding-left: 20px;
  padding-right: 20px;
}
.ant-carousel .slick-prev,
.ant-carousel .slick-next,
.ant-carousel .slick-prev:hover,
.ant-carousel .slick-next:hover {
  font-size: 22px;
  color: #cdd3dd;
}
.report-buttons-row {
  padding: 5px 0 18px;
}
.report-button-margin-right {
  margin-right: 8px;
}
.collection-filter-form {
  align-items: center;
  background: #fafafa;
  padding: 10px;
}
.table-card {
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  width: 100%;
  font-size: 12px;
  margin-bottom: 10px;
}
.icon-content-margin {
  margin-right: 5px;
}
.text-capitalize {
  text-transform: capitalize;
}
.cap-tag {
  border-radius: 12px;
}
.filter-form-button {
  margin-top: 28px;
  height: 42px;
}
.report-button-margin-left {
  margin-right: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/components/App.less","webpack://./src/assets/style/login.less","webpack://./src/assets/style/sidebar.less","webpack://./src/assets/style/header.less","webpack://./src/assets/style/common.less","webpack://./src/assets/style/dropdown.less"],"names":[],"mappings":"AAGA,gCAAgC;ACFhC;EACI,aAAA;EACA,mBAAA;EAGA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,4BAAA;EACA,yDAAA;ADEJ;ACCA;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;ADCJ;ACNA;EAOQ,kBAAA;EACA,cAAA;EACA,eAAA;ADER;ACXA;EAYQ,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;ADER;ACGQ;EACI,8BAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;ADDZ;ACEY;;;EAGI,8BAAA;EACA,gCAAA;ADAhB;ACpCA;EAyCQ,cAAA;EACA,sBAAA;EACA,kBAAA;ADFR;ACzCA;EA8CQ,WAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,2CAAA;ADFR;ACKA;EACI,cAAA;EACA,qBAAA;ADHJ;ACKA;EACI,YAAA;EACA,kBAAA;EACA,yBAAA;ADHJ;AEtEA;EACI,mBAAA;AFwEJ;AEzEA;EAGQ,mBAAA;EACA,eAAA;AFyER;AE7EA;;EAWY,2BAAA;EACA,sBAAA;AFsEZ;AElFA;EAeY,mBAAA;EACA,aAAA;AFsEZ;AEtFA;EAkBgB,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AFuEhB;AE5FA;EAwBgB,cAAA;EACA,aAAA;AFuEhB;AEpEgB;EACI,iBAAA;AFsEpB;AEnEY;;EACI,8BAAA;EACA,0CAAA;AFsEhB;AEnEQ;EAEQ,8BAAA;EACA,0CAAA;AFoEhB;AE5GA;EA4CY,eAAA;AFmEZ;AEhEI;EAGY,UAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;AFgEhB;AE3DA;;;EAGI,mBAAA;EACA,sBAAA;AF6DJ;AE3DE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;AF6DJ;AE3DE;EACE,mBAAA;EACA,cAAA;AF6DJ;AE3DE;EACE,2BAAA;AF6DJ;AE3DE;;;;EACE,cAAA;EACA,aAAA;AFgEJ;AE9DA;EACI,8BAAA;EACA,0CAAA;AFgEJ;AGrJI;EACI,2BAAA;EACA,eAAA;AHuJR;AGlJA;EACI,WAAA;AHoJJ;AACA,yBAAyB;AI5JzB;EACE,oBAAA;AJ8JF;AI3JA;;EAGI,gBAAA;EACA,eAAA;AJ4JJ;AIhKA;EASI,sBAAA;AJ0JJ;AInKA;EAYI,sBAAA;AJ0JJ;AItJA;EACE,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,+BAAA;AJwJF;AI7JA;EAOI,kBAAA;EACA,mBAAA;EACA,2BAAA;EACA,oCAAA;AJyJJ;AInKA;EAcM,eAAA;EACA,2BAAA;EACA,cAAA;AJwJN;AIxKA;EAqBI,iBAAA;EACA,cAAA;AJsJJ;AI5KA;EA4BM,sBAAA;AJmJN;AI/IA;EACE,eAAA;AJiJF;AIlJA;EAGI,aAAA;EACA,cAAA;AJkJJ;AI/IA;EACE,eAAA;AJiJF;AIlJA;EAGI,aAAA;EACA,cAAA;AJkJJ;AI/IA;EACE,WAAA;AJiJF;AI/IA;;;EAGE,yBAAA;EACA,yBAAA;EACA,YAAA;AJiJF;AACA,uBAAuB;AI7IrB;EAEE,YAAA;EACA,iBAAA;EAEA,eAAA;EACA,gBAAA;AJ6IJ;AIxII;EAKE,8BAAA;EACA,gCAAA;EACA,yBAAA;AJsIN;AIrIM;;;EAGE,8BAAA;EACA,gCAAA;EACA,yBAAA;AJuIR;AIjIM;;;;EAIE,8BAAA;EACA,gCAAA;EACA,qCAAA;EACA,mBAAA;EACA,gBAAA;AJmIR;AI9HI;EACE,8BAAA;EACA,gCAAA;EACA,yBAAA;AJgIN;AI/HM;;;EAGE,8BAAA;EACA,gCAAA;EACA,yBAAA;AJiIR;AIxHI;EACE,8BAAA;EACA,gCAAA;EACA,sBAAA;AJ0HN;AIzHM;;;EAGE,8BAAA;EACA,gCAAA;EACA,sBAAA;AJ2HR;AItGI;EACE,8BAAA;EACA,gCAAA;EACA,uBAAA;AJwGN;AIvGM;;;EAGE,8BAAA;EACA,gCAAA;EACA,uBAAA;AJyGR;AACA,4BAA4B;AIvF5B;EAeM,0BAAA;EACA,2BAAA;AJ2EN;AI/EM;EACE,yBAAA;AJiFR;AI9FA;EAkBQ,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AJ+ER;AIrGA;EA2BQ,cAAA;AJ6ER;AIxGA;EAiCM,cAAA;EACA,eAAA;EACA,gBAAA;AJ0EN;AI5DA;;EAIM,gBAAA;EACA,QAAA;EACA,UAAA;EACA,mBAAA;EACA,+CAAA;AJ4DN;AIpEA;;EAWM,gBAAA;EACA,QAAA;EACA,UAAA;EACA,mBAAA;EACA,+CAAA;AJ6DN;AI5EA;;EAkBM,mBAAA;AJ8DN;AIrDA;;EAGI,2BAAA;EACA,2BAAA;AJsDJ;AIjDI;EACE,cAAA;AJmDN;AI/CA;EAEI,aAAA;AJgDJ;AIlDA;EAKI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;AJgDJ;AI9CM;EACE,iBAAA;AJgDR;AI1CA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;AJ4CF;AIzCA;EACE,eAAA;AJ2CF;AI5CA;EAGI,aAAA;EACA,cAAA;AJ4CJ;AACA,yFAAyF;AIxCzF;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EAGA,gBAAA;EACA,iBAAA;EACA,0BAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,sBAAA;AJwCF;AItCE;EACE,qBAAA;EACA,mCAAA;AJwCJ;AI3DA;EAsBI,eAAA;EACA,cAAA;EACA,cAAA;AJwCJ;AIhEA;EA2BI,aAAA;EACA,sBAAA;EACA,gBAAA;EAGA,YAAA;EACA,gBAAA;AJsCJ;AIvEA;;EAoCM,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AJuCN;AI9EA;EA0CM,eAAA;EACA,gBAAA;EACA,cAAA;AJuCN;AInFA;EA+CM,eAAA;EACA,0BAAA;AJuCN;AInCE;EACE,mBAAA;EACA,YAAA;AJqCJ;AIpCI;EACE,qBAAA;EACA,mBAAA;AJsCN;AIjCE;EAAA;IACE,QAAA;IACA,iBAAA;EJoCF;EItCA;IAII,eAAA;EJqCJ;EIzCA;IAOI,eAAA;EJqCJ;AACF;AI1BA;EACE,cAAA;EACA,WAAA;AJ4BF;AI9BA;EAKI,cAAA;EACA,WAAA;AJ4BJ;AIvBA;;EAGI,kBAAA;EACA,gBAAA;AJwBJ;AACA,8EAA8E;AIhB9E;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,uBAAA;AJkBF;AACA,0BAA0B;AIf1B;EAEI,mBAAA;EACA,0CAAA;EACA,mBAAA;EACA,gBAAA;AJgBJ;AIrBA;EAQM,gCAAA;EACA,iBAAA;EACA,eAAA;AJgBN;AI1BA;EAaM,eAAA;AJgBN;AI7BA;EAgBM,aAAA;AJgBN;AIhCA;EAqBI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mCAAA;EACA,cAAA;EACA,eAAA;AJcJ;AI3CA;EAgCI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AJcJ;AIjDA;EAsCI,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,gBAAA;AJcJ;AIvDA;EA8CM,mBAAA;AJYN;AIVM;EACE,mBAAA;AJYR;AI7DA;EAqDQ,QAAA;AJWR;AIhEA;EAyDQ,mBAAA;EACA,sBAAA;EACA,6BAAA;EACA,4BAAA;EACA,yBAAA;AJUR;AIvEA;EAgEU,gBAAA;EACA,0BAAA;AJUV;AI3EA;EAoEU,0BAAA;EACA,gBAAA;AJUV;AITU;EACE,cAAA;AJWZ;AIRQ;EACE,cAAA;AJUV;AIrFA;EA+EQ,kCAAA;EACA,oCAAA;AJSR;AIzFA;EAmFU,yBAAA;AJSV;AI5FA;EAuFQ,6BAAA;EACA,qCAAA;EACA,yBAAA;EACA,2BAAA;AJQR;AIPQ;EACE,gCAAA;EACA,8CAAA;AJSV;AItGA;EAmGM,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;AJMN;AI5GA;EA4GM,aAAA;AJGN;AI/GA;EA+GM,kBAAA;AJGN;AIlHA;EAoHI,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACA,6BAAA;AJCJ;AI5HA;EA8HM,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AJCN;AACA;;;;;8EAK8E;AAC9E,yCAAyC;AIKzC;EACE;IACE,uBAAA;EJHF;EIEA;IAGI,kBAAA;IACA,mBAAA;EJFJ;AACF;AACA,mDAAmD;AIMnD;EACE;IACE,uBAAA;IACA,gBAAA;IACA,gBAAA;EJJF;EICA;IAKI,kBAAA;IACA,mBAAA;EJHJ;EIYA;;IAGI,4BAAA;EJXJ;EIgBA;IACE,6BAAA;IACA,iBAAA;EJdF;EIYA;IAII,aAAA;EJbJ;EIgBA;IACE,wBAAA;IACA,eAAA;EJdF;EIYA;IAII,cAAA;EJbJ;EIcI;IACE,cAAA;EJZN;AACF;AACA,+BAA+B;AIiB/B;EACE;IACE,uBAAA;IACA,gBAAA;EJfF;EIaA;IAII,kBAAA;IACA,mBAAA;EJdJ;EIsBA;IACE,aAAA;EJpBF;EImBA;IAGI,cAAA;IACA,eAAA;EJnBJ;EIeA;IAOI,eAAA;IACA,iBAAA;EJnBJ;EIWA;IAWI,cAAA;EJnBJ;EIQA;IAeI,WAAA;EJpBJ;EIwBA;;IAGI,eAAA;EJvBJ;EI2BA;IACE,eAAA;IACA,eAAA;EJzBF;EI6BA;;IAEE,iCAAA;EJ3BF;EI+BA;IACE,0BAAA;EJ7BF;EI4BA;;IAII,2BAAA;EJ5BJ;EIiCA;IACE,4BAAA;IACA,4BAAA;IACA,eAAA;EJ/BF;EImCA;IACE,iBAAA;EJjCF;EIgCA;IAGI,WAAA;EJhCJ;EI6BA;IAKM,cAAA;EJ/BN;EIqCA;IACE,aAAA;IACA,eAAA;IACA,YAAA;EJnCF;EIuCA;IACE,YAAA;IACA,mBAAA;EJrCF;AACF;AACA;;8EAE8E;AIyC9E;EACE,YAAA;AJvCF;AI2CA;EACE,aAAA;AJzCF;AI4CA;EACE;IACE,SAAA;EJ1CF;EIiDA;IACE,sBAAA;IACA,mBAAA;IACA,uBAAA;IACA,uBAAA;IACA,2BAAA;EJ/CF;EImDA;IACE,0BAAA;IACA,MAAA;IACA,OAAA;IACA,aAAA;IACA,aAAA;IACA,yCAAA;EJjDF;EIoDA;IACE,cAAA;IACA,eAAA;IACA,QAAA;IACA,aAAA;IACA,+BAAA;EJlDF;AACF;AKjtBA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;ALmtBF;AKhtBA;EACE,cAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;ALktBF;AK/sBA;EACE,eAAA;EACA,gBAAA;ALitBF;AK9sBA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,6BAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;ALgtBF;AK7sBA;EACE,YAAA;EL+sBA,mCAAmC;EK9sBnC,aAAA;ELgtBA,oCAAoC;EK/sBpC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;ALitBF;AK9sBA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;ALgtBF;AAvvBA;EAEI,+BAAA;AAwvBJ;AArvBA;EAEI,+BAAA;AAsvBJ;AApvBA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAiFE,SAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,wBAAA;EAEA,qCAAA;AAqvBF;AACA,gDAAgD;AAnvBhD;;;;;;;;;;;EAWE,cAAA;AAqvBF;AAnvBA;EACE,cAAA;AAqvBF;AAnvBA;;EAEE,gBAAA;AAqvBF;AAnvBA;;EAEE,YAAA;AAqvBF;AAnvBA;;;;EAIE,WAAA;EACA,aAAA;AAqvBF;AAnvBA;EACE,yBAAA;EACA,iBAAA;AAqvBF;AAnvBA;EACE,yDAAA;EACA,sDAAA;EACA,iDAAA;AAqvBF;AAnvBA;EACE,eAAA;EACA,4BAAA;EACA,2BAAA;EACA,2BAAA;AAqvBF;AAnvBA;EACE,uBAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,8BAAA;AAqvBF;AA/sBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAitBF;AA9sBA;EACE,YAAA;AAgtBF;AA9sBA;EACE,gBAAA;EACA,cAAA;EACA,qBAAA;AAgtBF;AA9sBE;EACE,yBAAA;EACA,cAAA;AAgtBJ;AA7sBA;EACE,gBAAA;AA+sBF;AA7sBA;EAGE,yBAAA;EACA,qBAAA;AA6sBF;AA3sBA;EAGE,yBAAA;EACA,qBAAA;AA2sBF;AAzsBA;EACE,4BAAA;AA2sBF;AA1rBA;EACE,gBAAA;EACA,YAAA;EACA,cAAA;AA4rBF;AAzrBA;EACE,eAAA;AA2rBF;AAzrBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;AA2rBF;AAtrBA;EACE,8BAAA;EACA,gCAAA;EACA,yBAAA;AAwrBF;AAtrBA;;EACE,yBAAA;AAyrBF;AAvrBA;;EACE,0BAAA;AA0rBF;AAjrBA;EACE,yBAAA;AAmrBF;AAjrBA;EACE,0BAAA;AAmrBF;AAjrBA;EACE,WAAA;AAmrBF;AAhrBA;EACE,aAAA;AAkrBF;AA/qBA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAirBF;AA/qBA;EACE,uBAAA;AAirBF;AA7qBA;EACE,kCAAA;AA+qBF;AA7qBA;EACE,kBAAA;EACA,mBAAA;AA+qBF;AA7qBA;;;;EACE,eAAA;EACA,cAAA;AAkrBF;AAhrBA;EACE,mBAAA;AAkrBF;AAhrBA;EACE,iBAAA;AAkrBF;AAhrBA;EACE,mBAAA;EACA,mBAAA;EACA,aAAA;AAkrBF;AA/qBA;EACE,mBAAA;EACA,wCAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;AAirBF;AA/qBA;EACE,iBAAA;AAirBF;AA/qBA;EACE,0BAAA;AAirBF;AA/qBA;EACE,mBAAA;AAirBF;AA/qBA;EACG,gBAAA;EACD,YAAA;AAirBF;AA/qBA;EACE,iBAAA;AAirBF","sourcesContent":["@import (css) url(\"https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500&display=swap\");\n@import (css) url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,400&display=swap');\n@import (css) url('https://fonts.googleapis.com/css2?family=Lato:wght@100;300;400;700;900&display=swap');\n@import \"../assets/style/variables.less\";\n@import \"./../assets/style/login.less\";\n@import \"../assets/style/sidebar.less\";\n@import \"../assets/style/header.less\";\n@import \"../assets/style/common.less\";\n@import \"../assets/style/dropdown.less\";\n\n* {\n//   font-family: 'Roboto'!important;\n    font-family: 'Lato', sans-serif;\n}\n\nbody {\n//   font-family: 'Roboto';\n    font-family: 'Lato', sans-serif;\n}\nhtml,\nbody,\ndiv,\nspan,\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd,\narticle,\naside,\ncanvas,\ndetails,\nembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\noutput,\nruby,\nsection,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font: inherit;\n  vertical-align: baseline;\n\n  font-family: \"Montserrat\", sans-serif;\n}\n/* HTML5 display-role reset for older browsers */\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\nsection {\n  display: block;\n}\nbody {\n  line-height: 1;\n}\nol,\nul {\n  list-style: none;\n}\nblockquote,\nq {\n  quotes: none;\n}\nblockquote:before,\nblockquote:after,\nq:before,\nq:after {\n  content: \"\";\n  content: none;\n}\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n.shadow {\n  -webkit-box-shadow: -1px 2px 9px -1px rgba(0, 0, 0, 0.34);\n  -moz-box-shadow: -1px 2px 9px -1px rgba(0, 0, 0, 0.34);\n  box-shadow: -1px 2px 9px -1px rgba(0, 0, 0, 0.34);\n}\nh4.ant-typography {\n  font-size: 16px;\n  line-height: 40px !important;\n  font-weight: 600 !important;\n  margin-bottom: 0 !important;\n}\nhr {\n  border: none !important;\n  height: 1px !important;\n  margin-bottom: 25px;\n  display: block !important;\n  background: #f0f0f0 !important;\n}\n\n//comman css\n\n// label {\n//   height: auto !important;\n//   font-family: \"Lato\", sans-serif;\n//   font-weight: bold !important;\n//   font-size: 12px !important;\n// }\n//.ant-form-item-control-input\n// .ant-input-affix-wrapper {\n//   background: #f1f1f1 !important;\n//   border: none !important;\n//   color: #000 !important;\n  //-webkit-box-shadow: 7px 10px 5px -10px rgba(0, 0, 0, 0.31);\n  //-moz-box-shadow: 7px 10px 5px -10px rgba(0, 0, 0, 0.31);\n  //box-shadow: 7px 10px 5px -10px rgba(0, 0, 0, 0.31);\n// }\n// input {\n//   background: #f1f1f1 !important;\n//   border: none !important;\n//   color: #000 !important;\n// }\n// textarea {\n//   background: #f1f1f1 !important;\n//   border: none !important;\n//   color: #000 !important;\n// }\n// .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {\n//   background: #f1f1f1 !important;\n//   border: none !important;\n//   color: #000 !important;\n  // -webkit-box-shadow: 7px 10px 5px -10px rgba(0, 0, 0, 0.31);\n  // -moz-box-shadow: 7px 10px 5px -10px rgba(0, 0, 0, 0.31);\n  // box-shadow: 7px 10px 5px -10px rgba(0, 0, 0, 0.31);\n// }\n.flexbox {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #ffffff;\n}\n\n.right-fl {\n  float: right;\n}\n.btn-white {\n  background: none;\n  color: inherit;\n  border-color: inherit;\n\n  &:hover {\n    background-color: inherit;\n    color: inherit;\n  }\n}\n.ant-radio-inner {\n  background: none;\n}\n.tab-title-grant\n  .ant-checkbox-checked:not(.ant-checkbox-disabled)\n  .ant-checkbox-inner {\n  background-color: #73c074;\n  border-color: #73c074;\n}\n.tab-title-revoke\n  .ant-checkbox-checked:not(.ant-checkbox-disabled)\n  .ant-checkbox-inner {\n  background-color: #df746a;\n  border-color: #df746a;\n}\nstrong {\n  font-weight: bold !important;\n}\n\n// .ant-btn-primary {\n//   border-radius: 30px !important;\n//   background-image: linear-gradient(#00b3ec, #074bc1);\n//   color: white;\n//   min-width: 125px;\n//   text-align: center;\n//   height: 40px !important;\n// }\n// .breadcrumb-list {\n//   padding-top: 10px;\n//   margin-bottom: 20px;\n//   margin-left: -10px;\n// }\n\n.ant-table-cell button {\n  background: none;\n  border: none;\n  color: #0067ae;\n}\n\n.ant-switch-inner{\n  padding:0 20px;\n}\n.labelLink .ant-form-item-label >label {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n// !important: antd v5's own modal-header rule is scoped as .ant-modal .ant-modal-header\n// (2 classes) vs this plain .ant-modal-header (1 class), so it now wins on class count —\n// v4's equivalent rule had no .ant-modal ancestor class, so this used to win outright.\n.ant-modal-header{\n  background: #212329 !important;\n  border-color: #212329 !important;\n  color: #ffffff !important;\n}\n.ant-modal-title,.ant-modal-close-x{\n  color: #ffffff !important;\n}\n.ant-modal-title,.ant-select-item-option-content{\n  text-transform: capitalize;\n}\n// `span.ant-breadcrumb-link` only ever matches plain-text (non-href) breadcrumb items — the\n// current/last item in a multi-level breadcrumb (e.g. \"Configurations\" in \"Settings /\n// Configurations\") and every single-item breadcrumb (e.g. \"Dashboard\"), since with no parent\n// the one item IS the current page. Actual clickable ancestor links render as\n// <a class=\"ant-breadcrumb-link\"> instead and are unaffected by this rule either way.\n// Confirmed directly against production's own compiled CSS: this exact rule is there —\n// an earlier removal (this session) was a mistake based on misreading one screenshot.\nspan.ant-breadcrumb-link {\n  color: #a6a300 !important;\n}\nselect{\n  text-transform: capitalize;\n}\n.carousel-container {\n  width: 100%;\n}\n\n.carousel-item {\n  padding: 10px;\n}\n\n.ant-carousel .slick-slide {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.slick-slide{\n  width: 370px !important;\n}\n\n\n.ant-table-cell{\n  overflow-wrap: anywhere !important;\n}\n.carousel-container{\n  padding-left: 20px;\n  padding-right: 20px;\n}\n.ant-carousel .slick-prev,.ant-carousel .slick-next,.ant-carousel .slick-prev:hover,.ant-carousel .slick-next:hover{\n  font-size: 22px;\n  color:#cdd3dd;\n}\n.report-buttons-row{\n  padding: 5px 0 18px;\n}\n.report-button-margin-right{\n  margin-right: 8px;\n}\n.collection-filter-form{\n  align-items: center;\n  background: #fafafa;\n  padding: 10px;\n}\n\n.table-card{\n  border-radius: 10px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  font-size: 12px;\n  margin-bottom:10px;\n}\n.icon-content-margin{\n  margin-right:5px;\n}\n.text-capitalize{\n  text-transform: capitalize;\n}\n.cap-tag{\n  border-radius: 12px;\n}\n.filter-form-button{\n   margin-top: 28px;\n  height: 42px;\n}\n.report-button-margin-left{\n  margin-right: 8px;\n}\n\n","/*** Login Page style starts ***/\n.login-p {\n    display: flex;\n    align-items: center;\n    //background-image: url(\"../images/logo-img.png\");\n    // background-color: #f1f1f1;\n    height: 100%;\n    min-height: 100vh;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-image: url(\"../images/bg-img.png\");\n \n}\n.login-section {\n    display: flex;\n    align-items: center;\n    height: 100%;\n    flex-direction: column;\n    padding: 10px 0;\n    .copyright {\n        text-align: center;\n        color: #595959;\n        font-size: 14px;\n    }\n    .form-card {\n        max-width: 480px;\n        width: 100%;\n        padding: 25px 30px;\n        margin: 5% auto;\n        background: #ffffff;\n        border: 1px solid #eee;\n        display: flex;\n        flex-wrap: wrap;\n        flex-direction: column;\n        border-radius: 10px;\n    }\n    .ant-btn-primary {\n        // !important: same reason as the general .ant-btn-primary override in common.less —\n        // antd v5's own hover/variant rules chain enough classes to outrank this otherwise.\n        &.login-button {\n            background: @primary-color !important;\n            border-color: @primary-color !important;\n            width: 100%;\n            height: 55px;\n            margin-top: 25px;\n            &:hover,\n            &:focus,\n            &:active {\n                background: @primary-color !important;\n                border-color: @primary-color !important;\n            }\n        }\n    }\n    .logo {\n        display: block;\n        margin: 15px auto 25px;\n        text-align: center;\n    }\n    .form-heading {\n        color: @text-color;\n        font-size: 35px;\n        font-weight: 700;\n        margin-bottom: 20px;\n        text-shadow: 0px 2px 5px rgba(0, 0, 0, .2);\n    }\n}\n.link-text {\n    color: @primary-color;\n    text-decoration: none;   \n}\n.ant-input-affix-wrapper {\n    height: 55px;\n    border-radius: 4px;\n    border: 1px solid @primary-color;\n}",".main-sidebar {\n    background: #212329;\n    .menu {\n        background: #212329;\n        border-right: 0;\n    }\n    .ant-menu {\n        .ant-menu-item, .ant-menu-submenu-title {\n            // antd v5 gives menu items a 4px inline margin + reduced width by default (v4 items\n            // were flush against the sider edge) — this leaves a visible gap between the\n            // highlighted background/olive border and the sidebar's right edge.\n            margin-inline: 0 !important;\n            width: 100% !important;\n        }\n        .ant-menu-item {\n            align-items: center;\n            display: flex;\n            a {\n                color: @white-clr;  \n                font-size: 16px;\n                font-weight: 400;  \n                line-height: 19px;\n            }\n            svg {\n                color: @white-clr;\n                fill: @white-clr;\n            }\n            .ant-menu-item-icon {\n                &+ span {\n                    margin-left: 20px;\n                }\n            }\n            &:hover, &:focus {\n                background: @list-active-bg !important;\n                border-right: 4px solid @primary-color !important;\n            }\n        }\n        &:not(.ant-menu-horizontal) {\n            .ant-menu-item-selected {\n                background: @list-active-bg !important;\n                border-right: 4px solid @primary-color !important;\n            }\n        }\n        .sidebar-icon {\n            font-size: 20px;\n        }\n    }\n    &.ant-layout-sider {\n        .logo-img {\n            img {\n                width: 80%;\n                padding: 5px 0 15px;\n                display: block;\n                object-fit: contain;\n                margin: 0 auto 15px;\n            }\n        }\n    }\n}\n.ant-menu.ant-menu-dark,\n.ant-menu-dark .ant-menu-sub,\n.ant-menu.ant-menu-dark .ant-menu-sub{\n    background: #212329;\n    width: 100% !important;\n}\n  .ant-menu-submenu {\n    color: #ffffff;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 19px;\n    background: #212329;\n    border-right: 0;\n  }\n  .ant-menu-sub.ant-menu-inline {\n    background: #212329;\n    color: #ffffff;\n}\n  .ant-menu-inline.ant-menu-root .ant-menu-submenu-title > .ant-menu-title-content {\n    margin-left: 20px!important;\n  }\n  .ant-menu-title-content,.ant-menu-submenu-inline,.ant-menu-submenu-arrow,.ant-menu-submenu-title svg{\n    color: #ffffff;\n    fill: #ffffff;\n  }\n.ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected {\n    background: @list-active-bg !important;\n    border-right: 4px solid @primary-color !important;\n}\n\n\n  ",".ant-layout-header {\n    &.header {\n        background: #fff !important;\n        padding: 0 25px;\n    }\n}\n\n// Create object component \n.create_object .ant-upload{\n    width:100%;\n}\n","/*** breadcrumb style ***/\n\n.app-breadcrumb-col {\n  padding: 15px 24px 0;\n}\n\n.ant-breadcrumb {\n  .ant-breadcrumb-link,\n  .ant-breadcrumb-separator {\n    font-weight: 500;\n    font-size: 16px;\n  }\n  // Only the <a> (ancestor link) gets the plain text color here — the current-page <span>\n  // is styled olive by `span.ant-breadcrumb-link` in App.less, and must stay higher priority.\n  a.ant-breadcrumb-link {\n    color: @text-color !important;\n  }\n  .ant-breadcrumb-separator {\n    color: @text-color !important;\n  }\n}\n\n.white-paper {\n  background: @white-clr;\n  padding: 15px 24px 24px;\n  margin-top: 20px;\n  width: 100%;\n  min-height: calc(100vh - 200px);\n  hr {\n    margin-left: -24px;\n    margin-right: -24px;\n    margin-top: 15px !important;\n    background-color: #cfcfcf !important;\n  }\n  .page-header-section {\n    h4 {\n      font-size: 18px;\n      font-weight: 700 !important;\n      color: @title-clr;\n    }\n  }\n\n  .align-right {\n    margin-left: auto;\n    display: block;\n    // antd v5's Button spaces its icon from the label via `gap` on its own\n    // `display: inline-flex`, which this `display: block` override defeats\n    // (`gap` only applies to flex/grid containers). v4 used icon margins\n    // instead, so this rule never conflicted with icon spacing before.\n    .ant-btn-icon {\n      margin-inline-end: 8px;\n    }\n  }\n}\n.edit-btn {\n  cursor: pointer;\n  svg {\n    fill: @table-icon-clr;\n    color: @table-icon-clr;\n  }\n}\n.complete-btn {\n  cursor: pointer;\n  svg {\n    fill: @primary-color;\n    color: @primary-color;\n  }\n}\n.ant-picker {\n  width: 100%;\n}\n.ant-input,\n.ant-select:not(.ant-select-customize-input) .ant-select-selector,\n.ant-picker {\n  background-color: #fcfcfc;\n  border: 1px solid #e5e5e5;\n  height: 40px;\n}\n\n/*** buttons design ***/\nbutton {\n  &.ant-btn {\n    // height: 48px;\n    height: 40px;\n    padding: 0px 15px;\n    // padding: 10px 20px;\n    font-size: 16px;\n    font-weight: 400;\n    // :not(.login-button) — login.less gives the login submit button its own solid\n    // @primary-color (olive) look, deliberately different from every other primary button.\n    // That rule has no !important, so without this exclusion the blanket override below\n    // (needed for v5's specificity, see comment) would also flatten the login button to dark.\n    &.ant-btn-primary:not(.login-button):not(.save-btn) {\n      // antd v5's own color+variant system (.ant-btn-variant-solid:not(:disabled):not(.ant-btn-disabled):hover)\n      // has higher specificity (4 class-level selectors) than this rule could match without !important,\n      // even with :hover/:focus/:active added — v4 never had this many chained selectors on its own\n      // hover rule, so this override always won there without needing !important. Forcing it here too.\n      background: #212329 !important;\n      border-color: #212329 !important;\n      color: @white-clr !important;\n      &:hover,\n      &:focus,\n      &:active {\n        background: #212329 !important;\n        border-color: #212329 !important;\n        color: @white-clr !important;\n      }\n    }\n    // The blanket primary override above also matched disabled buttons, so e.g. Export CSV\n    // (disabled until rows are selected) looked fully active. Restore a greyed-out look.\n    &.ant-btn-primary:not(.login-button):not(.save-btn) {\n      &:disabled,\n      &.ant-btn-disabled,\n      &:disabled:hover,\n      &.ant-btn-disabled:hover {\n        background: #f5f5f5 !important;\n        border-color: #d9d9d9 !important;\n        color: rgba(0, 0, 0, 0.25) !important;\n        cursor: not-allowed;\n        box-shadow: none;\n      }\n    }\n    // Same v5-specificity story as .ant-btn-primary above: without !important, antd's own\n    // higher-specificity hover/focus rule wins and the Save button falls back to stock blue.\n    &.save-btn {\n      background: @primary-color !important;\n      border-color: @primary-color !important;\n      color: @white-clr !important;\n      &:hover,\n      &:focus,\n      &:active {\n        background: @primary-color !important;\n        border-color: @primary-color !important;\n        color: @white-clr !important;\n      }\n    }\n    // @btn-danger-* (variables.less) used to reach every `danger`/`type=\"danger\"` button only\n    // through antd v4's Less theme compilation (`@import \"~antd/dist/antd.less\"` in App.less,\n    // removed since v5 ships no Less at all). Without it these variables were dead and every\n    // danger button (Reset in table filter dropdowns, Cancel buttons, etc.) fell back to antd\n    // v5's stock outlined red instead of this app's solid-filled one. Restoring it directly,\n    // same !important pattern as .ant-btn-primary above and for the same reason.\n    &.ant-btn-dangerous {\n      background: @btn-danger-bg !important;\n      border-color: @btn-danger-border !important;\n      color: @btn-danger-color !important;\n      &:hover,\n      &:focus,\n      &:active {\n        background: @btn-danger-bg !important;\n        border-color: @btn-danger-border !important;\n        color: @btn-danger-color !important;\n      }\n    }\n    // @btn-default-* (variables.less) — same dead-Less-theme-variable story as\n    // .ant-btn-dangerous above, just for the plain (no `type` prop) button. Without it,\n    // e.g. confirmationModal's \"Incomplete\"/first-button choice fell back to antd v5's\n    // stock white/outlined default instead of this app's solid-filled one.\n    // :not(.ant-btn-dangerous) — a <Button danger> with no explicit type (e.g. filter()'s\n    // Reset button in common_functions/index.js) gets BOTH .ant-btn-default AND\n    // .ant-btn-dangerous classes simultaneously (antd's mergedType falls back to 'default'\n    // when only `danger` is set). Both rules carry !important with equal specificity, so\n    // without this exclusion, source order alone decided the winner — this rule, added\n    // later, was silently overriding every plain `danger`-only button back to green.\n    //\n    // :not([style]) — every \"Back\" button across the app (~39 usages) is a plain default\n    // button with its own inline style (light-gray #f5f5f5/#d9d9d9/rgba(0,0,0,.85), matching\n    // production's compiled CSS exactly — verified directly against it: prod never darkens\n    // or greens .ant-btn-default at all). Buttons that genuinely want this app's green\n    // default look (e.g. confirmationModal's first button in common_functions/index.js) are\n    // never given an inline style, so this exclusion is a reliable, single, app-wide way to\n    // leave every \"Back\" button's original design alone without touching all 39 files.\n    &.ant-btn-default:not(.ant-btn-dangerous):not([style]) {\n      background: @btn-default-bg !important;\n      border-color: @btn-default-border !important;\n      color: @btn-default-color !important;\n      &:hover,\n      &:focus,\n      &:active {\n        background: @btn-default-bg !important;\n        border-color: @btn-default-border !important;\n        color: @btn-default-color !important;\n      }\n    }\n  //   &.ant-btn-sm{\n\n  //     height: 24px;\n  //     padding: 0px 7px;\n  //     font-size: 14px;\n  //     border-radius: 4px\n  // }\n  }\n}\n\n// The general fix for every table's column-width/Actions-column overflow issue lives in\n// src/common_functions/fixTableWidths.js (wired up globally in App.js), not here — see that\n// file for the root-cause explanation. A one-off CSS override used to live here for this\n// page specifically before the general fix existed; it's superseded now.\n\n/*** Table layout design ***/\ntable {\n  .ant-table-thead {\n    th {\n      // antd v5 sets font-weight 600 (fontWeightStrong) and color rgba(0,0,0,.85) directly on\n      // th via a rule scoped under .ant-table-wrapper, which now out-specifies this selector\n      // (v4's equivalent base rule had no wrapper class, so this used to win outright). Columns\n      // with a sorter/filter wrap their title in a span (matched below) and were already fine;\n      // this direct th rule is what keeps plain columns (e.g. Sr. No., Actions) visually\n      // consistent with the rest of the header row instead of rendering bolder/darker.\n      // Excludes .dark-table-header (HeaderCell, used on the Roles Permissions table): that\n      // component deliberately sets its own inline white-on-navy colors, which this !important\n      // color rule would otherwise stomp on, making that header nearly unreadable.\n      &:not(.dark-table-header) {\n        color: @table-text !important;\n      }\n      font-size: 14px !important;\n      font-weight: 500 !important;\n      span {\n        color: @table-text;\n        font-size: 14px;\n        font-weight: 500;\n        white-space: normal;\n        word-wrap: break-word;\n        // overflow-wrap: break-word;\n        // word-break: break-all;\n      }\n      .ant-table-filter-trigger.active span {\n        color: @primary-color;\n      }\n    }\n  }\n  .ant-table-tbody {\n    td {\n      color: @table-text;\n      font-size: 14px;\n      font-weight: 400;\n    }\n  }\n}\n\n// Pin the last column (Actions, by convention in most list tables in this app) to the right\n// edge while the rest of the table scrolls horizontally underneath it — rather than editing\n// every table's columns config to add antd's `fixed: 'right'` column prop (which needs its\n// own separate rendered sub-table), a plain CSS `position: sticky` on the last header/body\n// cell achieves the same result generically, for every table, in one place. Needs an opaque\n// background (transparent would let scrolled-under cells show through) and a divider so it\n// doesn't visually blend into the scrolling content behind it.\n// Tables whose last column is NOT an Action column (e.g. Description) opt out via\n// `className=\"no-fixed-last-col\"` on the antd <Table>, so their last column scrolls normally.\n.ant-table-content,\n.ant-table-container {\n  table {\n    .ant-table-thead > tr > th:last-child {\n      position: sticky;\n      right: 0;\n      z-index: 2;\n      background: #fafafa;\n      box-shadow: -6px 0 6px -6px rgba(0, 0, 0, 0.15);\n    }\n    .ant-table-tbody > tr > td:last-child {\n      position: sticky;\n      right: 0;\n      z-index: 1;\n      background: @white-clr;\n      box-shadow: -6px 0 6px -6px rgba(0, 0, 0, 0.15);\n    }\n    .ant-table-tbody > tr:hover > td:last-child {\n      background: #fafafa;\n    }\n  }\n}\n// Opt-out for tables whose last column isn't an Action column (e.g. Description) —\n// undo the sticky pin above so that column scrolls normally with the rest of the table.\n// !important is required: the pin rule above matches with higher CSS specificity (it also\n// selects through the `table` element), so a same-or-lower-specificity override here would\n// lose to it regardless of source order.\n.no-fixed-last-col {\n  .ant-table-thead > tr > th:last-child,\n  .ant-table-tbody > tr > td:last-child {\n    position: static !important;\n    box-shadow: none !important;\n  }\n}\nbutton {\n  &.ant-btn {\n    &.ant-btn-link {\n      color: @primary-color;\n    }\n  }\n}\n.custom_modal {\n  .ant-modal-confirm-btns {\n    display: none;\n  }\n  .custom_button {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    margin-top: 20px;\n    button {\n      &:last-child {\n        margin-left: 10px;\n      }\n    }\n  }\n}\n\n.disabledComponent {\n  pointer-events: none;\n  cursor: not-allowed;\n  opacity: 0.3;\n}\n\n.print-icon {\n  cursor: pointer;\n  svg {\n    fill: @table-icon-clr;\n    color: @table-icon-clr;\n  }\n}\n\n/*** Shared upload trigger — used by every <Upload> in the app (see UploadTrigger.js) ***/\n.bp-upload-trigger {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  // min-height, not height: a wrapped label must grow the box instead of\n  // spilling out of it in a narrow column.\n  min-height: 52px;\n  padding: 8px 16px;\n  border: 1px dashed #c9c9c9;\n  border-radius: 8px;\n  background: #fafafa;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: left;\n  box-sizing: border-box;\n\n  &:hover {\n    border-color: @primary-color;\n    background: fade(@primary-color, 6%);\n  }\n  .bp-upload-trigger-icon {\n    font-size: 18px;\n    color: @primary-color;\n    flex-shrink: 0;\n  }\n  .bp-upload-trigger-text {\n    display: flex;\n    flex-direction: column;\n    line-height: 1.3;\n    // min-width: 0 is what lets a flex child shrink below its content width.\n    // Without it the text overflows the dashed border instead of ellipsing.\n    min-width: 0;\n    overflow: hidden;\n    span,\n    small {\n      display: block;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n    span {\n      font-size: 14px;\n      font-weight: 500;\n      color: @title-clr;\n    }\n    small {\n      font-size: 11px;\n      color: @text-color-secondary;\n    }\n  }\n\n  &.bp-upload-trigger--disabled {\n    cursor: not-allowed;\n    opacity: 0.5;\n    &:hover {\n      border-color: #c9c9c9;\n      background: #fafafa;\n    }\n  }\n\n  // Phones / very narrow columns: reclaim horizontal room for the text.\n  @media (max-width: @screen-xs-max) {\n    gap: 8px;\n    padding: 8px 12px;\n    .bp-upload-trigger-icon {\n      font-size: 16px;\n    }\n    .bp-upload-trigger-text span {\n      font-size: 13px;\n    }\n  }\n}\n\n// antd renders the click target as\n//   <span> > .ant-upload-select (inline-block) > span.ant-upload > our trigger\n// Because .ant-upload-select is inline-block, `width: 100%` on the trigger\n// resolved against a shrink-to-fit box, so each upload ended up only as wide as\n// its own hint text — different widths field to field, all narrower than the\n// inputs beside them. Stretch both wrappers so every trigger matches its column.\n// picture-card is excluded: those are deliberately square thumbnails.\n.ant-upload.ant-upload-select:not(.ant-upload-select-picture-card) {\n  display: block;\n  width: 100%;\n\n  > .ant-upload {\n    display: block;\n    width: 100%;\n  }\n}\n\n// Uploaded-file rows sit directly under the trigger, so keep them visually matched.\n.ant-upload-list-picture,\n.ant-upload-list-text {\n  .ant-upload-list-item {\n    border-radius: 8px;\n    margin-top: 10px;\n  }\n}\n\n/*** \"Already uploaded\" tick beside an upload label (see UploadedCheck.js) ***/\n// A vertical form label is content-sized (antd sets `height: auto`), so a tick\n// taller than the 14px text line grows the label and pushes that column's field\n// below its neighbour's — the two halves of a Row end up staggered. 16px sits\n// inside the line box; the old inline 170% (≈24px, plus 2px padding) did not.\n.bp-uploaded-check {\n  margin-left: 6px;\n  color: green;\n  font-size: 16px;\n  line-height: 1;\n  vertical-align: -0.15em;\n}\n\n/*** Basic Photos page ***/\n.basic-photo-page {\n  .bp-section-card {\n    border-radius: 10px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);\n    margin-bottom: 20px;\n    overflow: hidden;\n\n    .ant-card-head {\n      border-bottom: 1px solid #f0f0f0;\n      min-height: unset;\n      padding: 0 20px;\n    }\n    .ant-card-head-title {\n      padding: 14px 0;\n    }\n    .ant-card-body {\n      padding: 20px;\n    }\n  }\n\n  .bp-section-icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 34px;\n    height: 34px;\n    border-radius: 8px;\n    background: fade(@primary-color, 12%);\n    color: @primary-color;\n    font-size: 16px;\n  }\n  .bp-section-title {\n    font-size: 15px;\n    font-weight: 700;\n    color: @title-clr;\n    line-height: 1.3;\n  }\n  .bp-section-desc {\n    font-size: 12px;\n    font-weight: 400;\n    color: @text-color-secondary;\n    line-height: 1.3;\n  }\n\n  .bp-array-tabs {\n    > .ant-tabs-nav {\n      margin-bottom: 16px;\n\n      &::before {\n        border-bottom: none;\n      }\n\n      .ant-tabs-nav-list {\n        gap: 8px;\n      }\n\n      .ant-tabs-tab {\n        background: #fafafa;\n        border: 1px solid #eee;\n        border-radius: 8px !important;\n        padding: 8px 16px !important;\n        transition: all 0.2s ease;\n\n        .ant-tabs-tab-btn {\n          font-weight: 500;\n          color: @text-color-secondary;\n        }\n        .ant-tabs-tab-remove {\n          color: @text-color-secondary;\n          margin-left: 8px;\n          &:hover {\n            color: @danger;\n          }\n        }\n        &:hover .ant-tabs-tab-btn {\n          color: @primary-color;\n        }\n      }\n      .ant-tabs-tab-active {\n        background: fade(@primary-color, 10%);\n        border-color: fade(@primary-color, 40%);\n\n        .ant-tabs-tab-btn {\n          color: @primary-color !important;\n        }\n      }\n      .ant-tabs-nav-add {\n        border-radius: 8px !important;\n        border: 1px dashed #c9c9c9 !important;\n        color: @primary-color !important;\n        background: #fff !important;\n        &:hover {\n          border-color: @primary-color !important;\n          background: fade(@primary-color, 6%) !important;\n        }\n      }\n    }\n\n    .ant-tabs-tabpane {\n      background: #fafafa;\n      border: 1px solid #f0f0f0;\n      border-radius: 8px;\n      padding: 16px 16px 2px;\n    }\n  }\n\n  .bp-preview-modal {\n    .ant-modal-body {\n      padding: 16px;\n    }\n    img {\n      border-radius: 8px;\n    }\n  }\n\n  .bp-footer-bar {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    flex-wrap: wrap;\n    gap: 12px;\n    margin-top: 8px;\n    padding-top: 20px;\n    border-top: 1px solid #f0f0f0;\n\n    .bp-footer-actions {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      flex-wrap: wrap;\n    }\n  }\n}\n\n/* =========================================================================\n   Responsive layer\n   Built on antd's own breakpoints so it tracks the grid the JSX uses:\n     @screen-xs-max 575px | @screen-sm-max 767px | @screen-md-max 991px\n   Desktop (>=lg) is deliberately untouched.\n   ========================================================================= */\n\n/* ---- Tablet and below (<=991px) ---- */\n@media (max-width: @screen-md-max) {\n  .white-paper {\n    padding: 14px 18px 18px;\n    hr {\n      margin-left: -18px;\n      margin-right: -18px;\n    }\n  }\n}\n\n/* ---- Small tablet / large phone (<=767px) ---- */\n@media (max-width: @screen-sm-max) {\n  .white-paper {\n    padding: 12px 14px 16px;\n    margin-top: 14px;\n    min-height: auto;\n    hr {\n      margin-left: -14px;\n      margin-right: -14px;\n    }\n  }\n\n  // Long report/settings tables get denser so more columns fit before scrolling.\n  // !important: antd v5's own cell-padding rule is scoped under .ant-table-wrapper, which\n  // ties this selector's class count and then wins on element count (tr > th vs th alone) —\n  // in v4 that wrapper class didn't exist and this rule won outright, so the table simply\n  // never used to shrink at this breakpoint post-upgrade without forcing it back.\n  .ant-table {\n    .ant-table-thead th,\n    .ant-table-tbody td {\n      padding: 10px 8px !important;\n    }\n  }\n\n  // antd modals default to 520px, which overflows a phone viewport.\n  .ant-modal {\n    max-width: calc(100vw - 24px);\n    margin: 12px auto;\n    .ant-modal-body {\n      padding: 16px;\n    }\n  }\n  .custom_modal .custom_button {\n    justify-content: stretch;\n    flex-wrap: wrap;\n    button {\n      flex: 1 1 auto;\n      &:last-child {\n        margin-left: 0;\n      }\n    }\n  }\n}\n\n/* ---- Phones (<=575px) ---- */\n@media (max-width: @screen-xs-max) {\n  .white-paper {\n    padding: 10px 12px 14px;\n    border-radius: 0;\n    hr {\n      margin-left: -12px;\n      margin-right: -12px;\n    }\n  }\n\n  // Title + action button stack instead of splitting a ~370px row in half.\n  // Scoped under .white-paper to outrank the base rules defined there\n  // (.white-paper .page-header-section h4 would otherwise win on specificity)\n  // and antd's own .ant-col-xs-12.\n  .white-paper .page-header-section {\n    row-gap: 10px;\n    > .ant-col {\n      flex: 0 0 100%;\n      max-width: 100%;\n    }\n    h4 {\n      font-size: 16px;\n      line-height: 1.35;\n    }\n    .align-right {\n      margin-left: 0;\n    }\n    // Full-width primary action reads as a deliberate mobile CTA.\n    .ant-btn {\n      width: 100%;\n    }\n  }\n\n  .app-breadcrumb-col .ant-breadcrumb {\n    .ant-breadcrumb-link,\n    .ant-breadcrumb-separator {\n      font-size: 13px;\n    }\n  }\n\n  button.ant-btn {\n    font-size: 14px;\n    padding: 0 12px;\n  }\n\n  // Keep the horizontal table scroll comfortable on touch devices.\n  .ant-table-content,\n  .ant-table-body {\n    -webkit-overflow-scrolling: touch;\n  }\n  // Same .ant-table-wrapper specificity issue as the sm breakpoint above — !important needed\n  // to still win against antd v5's own table font-size/padding rules at this narrower width.\n  .ant-table {\n    font-size: 13px !important;\n    .ant-table-thead th,\n    .ant-table-tbody td {\n      padding: 8px 6px !important;\n    }\n  }\n\n  // Tab bars (print object, permissions) scroll rather than squash.\n  .ant-tabs-nav .ant-tabs-tab {\n    margin: 0 4px 0 0 !important;\n    padding: 8px 10px !important;\n    font-size: 13px;\n  }\n\n  // Form action rows: buttons go full-width and stack in reading order.\n  .bp-footer-bar {\n    padding-top: 14px;\n    .bp-footer-actions {\n      width: 100%;\n      .ant-btn {\n        flex: 1 1 100%;\n      }\n    }\n  }\n\n  // Pagination wraps instead of forcing the page wider than the viewport.\n  .ant-pagination {\n    display: flex;\n    flex-wrap: wrap;\n    row-gap: 8px;\n  }\n\n  // Nothing should push the page wider than the screen.\n  .ant-form-item-label > label {\n    height: auto;\n    white-space: normal;\n  }\n}\n\n/* =========================================================================\n   App shell: content spacing + phone sider behaviour\n   ========================================================================= */\n\n.app-content {\n  margin: 20px;\n}\n\n// Dismiss layer for the overlaid sider. Phones only — hidden from sm up.\n.sider-backdrop {\n  display: none;\n}\n\n@media (max-width: @screen-xs-max) {\n  .app-content {\n    margin: 0;\n  }\n\n  // Collapsed: reclaim the whole 80px icon rail — on a 375px screen that rail\n  // was eating 21% of the viewport.\n  // !important is required: antd's Sider writes width/minWidth/maxWidth/flexBasis\n  // as inline styles, and MainLayout's siderStyle sets overflow inline too.\n  .main-sidebar.ant-layout-sider-collapsed {\n    flex: 0 0 0 !important;\n    width: 0 !important;\n    min-width: 0 !important;\n    max-width: 0 !important;\n    overflow: hidden !important;\n  }\n\n  // Expanded: float above the page instead of squeezing it to ~145px.\n  .main-sidebar:not(.ant-layout-sider-collapsed) {\n    position: fixed !important;\n    top: 0;\n    left: 0;\n    height: 100vh;\n    z-index: 1002;\n    box-shadow: 2px 0 14px rgba(0, 0, 0, 0.3);\n  }\n\n  .sider-backdrop {\n    display: block;\n    position: fixed;\n    inset: 0;\n    z-index: 1001;\n    background: rgba(0, 0, 0, 0.45);\n  }\n}\n",".enlarged-image-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  max-width: 50%;\n  max-height: 50%;\n  padding: 20px;\n  text-align: center;\n  position: relative;\n}\n\n.modal-content img {\n  max-width: 100%;\n  max-height: 100%;\n}\n\n.modal-content button {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  font-size: 20px;\n}\n\n.avatar-container {\n  width: 230px; /* Set the width of the container */\n  height: 230px; /* Set the height of the container */\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.avatar-image {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n  object-position: center;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
